import { API_BASE } from './apiConfig'

function apiUrl(path) {
  const clean = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE}${clean}`
}

export async function loginWithGoogle(credential) {
  const res = await fetch(apiUrl('/api/auth/google'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ credential }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Google sign-in failed (${res.status})`)
  }
  return json?.data
}

export async function loginWithEmailPassword({ email, password }) {
  const res = await fetch(apiUrl('/api/auth/login'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Sign in failed (${res.status})`)
  }
  return json?.data
}

export async function registerCustomer({ name, email, password, phone }) {
  const res = await fetch(apiUrl('/api/auth/register'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ name, email, password, phone }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Registration failed (${res.status})`)
  }
  return json?.data
}

export async function checkEmail(email) {
  const res = await fetch(apiUrl('/api/auth/check-email'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Check email failed (${res.status})`)
  }
  return json?.data
}

export async function requestPasswordReset(email) {
  const res = await fetch(apiUrl('/api/auth/forgot-password'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Reset request failed (${res.status})`)
  }
  return json?.data
}

export async function resetPassword({ token, password }) {
  const res = await fetch(apiUrl('/api/auth/reset-password'), {
    method: 'POST',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, password }),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Password reset failed (${res.status})`)
  }
  return json?.data
}

export async function fetchProfile(token) {
  const res = await fetch(apiUrl('/api/auth/me'), {
    method: 'GET',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Failed to load profile (${res.status})`)
  }
  return json?.data
}

export async function updateProfile(token, fields) {
  const res = await fetch(apiUrl('/api/customer/profile'), {
    method: 'PATCH',
    mode: 'cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(fields),
  })
  const json = await res.json().catch(() => null)
  if (!res.ok) {
    throw new Error(json?.error?.message || `Failed to update profile (${res.status})`)
  }
  return json?.data
}
